<script>
  import Icon from "./Icon.svelte";

  export let href;
</script>

<a
  {href}
  class="flex flex-col gap-8 place-items-center px-16 py-8 lg:py-16 text-size-12 lg:text-size-14 text-neutral-900 bg-neutral-100 rounded-l-10 outline outline-transparent hover:outline-1 hover:outline-neutral-300 active:outline-1 active:outline-neutral-900 focus:outline-1 focus:outline-cyan-700 focus:rounded-l-10 focus:rounded-r-0 focus:!bg-neutral-100 focus-visible:outline-1 focus-visible:outline-cyan-700 focus-visible:rounded-l-10 focus-visible:rounded-r-0 focus-visible:!bg-cyan-50 focus-visible:shadow-btn-focus-dark"
  id="back-to-top"
>
  <Icon type="chevron-back-to-top" size="md" />
  <span class="font-gotham font-bold underline underline-offset-2">Back to Top</span>
</a>
